export const COURSE_SUGGESTION = 'COURSE_SUGGESTION';
export const DEFAULT_GREETINGS =
  "I'm your AI Companion Bot ready to assist you. Whether you need course recommendations, help choosing the right path, or guidance on learning a specific framework, just ask! Let's dive into learning together! 📚";
export const VIDEO_COMPANION = 'VIDEO_COMPANION';
export const COURSE_OUTLINE = 'COURSE_OUTLINE';
export const QUIZ_GENERATOR = 'QUIZ_GENERATOR';
export const QUIZ_GENERATOR_CONVERTER = 'QUIZ_GENERATOR_CONVERTER';
